module.exports = __webpack_public_path__ + "assets/img/contact_en.274609c5.jpg";